<template>
  <div class="order-container">
    <OrderCardHeader :order-number="order.orderNumber" :order-date="order.orderDate" :order-token="orderTokenParams" />

    <div v-if="isTrackPackage">
      <ProductThumbnailWrapper
        v-for="(shipment, index) in order.shipments"
        :key="index"
        show-buy-again
        :products="transformProducts(shipment.items)"
        :is-red-carpet-shipment="isRedCarpetShipment"
        page="track-package"
        :is-buy-again-slideout-enabled="isBuyAgainSlideoutEnabled"
      />
    </div>
    <div v-else>
      <PurchaseCarton
        v-for="(shipment, index) in order.shipments"
        :key="index"
        class="order-carton padding-bottom-m"
        :shipment="getShipment(shipment)"
        :read-only="shipment?.orderWithoutShipment"
        group-items
      />
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import OrderCardHeader from '@/components/common/OrderCardHeader';
import PurchaseCarton from '@/components/ppe/PurchaseCarton';
import ProductThumbnailWrapper from '@/components/common/ProductThumbnailWrapper';
import { transformProducts } from '@/utils/TransformProduct';

const props = defineProps({
  order: {
    type: Object,
    required: true,
  },
  isTrackPackage: {
    type: Boolean,
    required: false,
    default: false,
  },
  isRedCarpetShipment: {
    type: Boolean,
    required: false,
    default: false,
  },
  isBuyAgainSlideoutEnabled: {
    type: Boolean,
    default: false,
  },
});

const locksFlag = computed(() => {
  const hasBackorder = props.order?.shipments?.some((shipment) => {
    return shipment?.shipmentStatusCode === 111;
  });
  return hasBackorder ? 'Y' : 'N';
});

const orderTokenParams = computed(() => {
  if (props.isTrackPackage && props.order?.shipments?.[0]?.orderToken) {
    return { o: props.order.shipments[0].orderToken };
  }
  if (!props.isTrackPackage) {
    return { locksFlag: locksFlag.value };
  }

  return undefined;
});

const getShipment = (shipment) => shipment;
</script>

<style lang="scss" scoped>
.order-container {
  &:last-child {
    margin-bottom: rem-calc(32) !important;
  }
  .order-carton {
    &:last-child {
      border-bottom: none;
      padding-bottom: 0;
    }
  }
}
</style>
